import { AppFunctionComponent, QueryResultFlat } from "../../../../../types"
import React from "react"
import {
  QuickStartProps,
  QuickStarterQueryData,
} from "./quick-start-element.interface"
import { graphql, useStaticQuery } from "gatsby"
import TextWithEmbedResolver from "../../../../../resolvers/text-with-embed/text-with-embed.resolver"
import {
  QuickStartSectionWrapper,
  StyledDesktopListItem,
} from "./quick-start-element.styled"
import { useLocalizationContext } from "../../../../../context/localization.context"
import QuickStartManualsTable from "../quick-start/quick-start-manuals-table.component"
import QuickStartHeadingText from "../quick-start/quick-start-heading-text.component"
import RichText from "../../../../../resolvers/rich-text/rich-text.resolver"

function resolvePolishVersion<T extends { node_locale?: string }>(
  obj: QueryResultFlat<T>,
  locale: string
): T {
  return obj.nodes.find((el) => el.node_locale === locale) || obj.nodes[0]
}

// const transformListObject = (obj: ListBuilder, hash: string) => {
//   return { hash, ...obj }
// }

const QuickStartElement: AppFunctionComponent<QuickStartProps> = ({
  config,
}) => {
  const {
    modules: { manuals },
  } = config

  const {
    list_one,
    list_two,
    list_three,
    list_four,
    contentfulText,
    howToUse_1,
    howToUse_2,
    care_1,
    care_2,
    care_3,
    care_4,
    changeStraps_1,
    changeStraps_2,
    download_1,
  } = useStaticQuery<QuickStarterQueryData>(query)
  const { locale } = useLocalizationContext()

  const listOne = resolvePolishVersion(list_one, locale)
  const listTwo = resolvePolishVersion(list_two, locale)
  const listThree = resolvePolishVersion(list_three, locale)
  const listFour = resolvePolishVersion(list_four, locale)
  const headingText = resolvePolishVersion(contentfulText, locale)
  const howToUse1 = resolvePolishVersion(howToUse_1, locale)
  const howToUse2 = resolvePolishVersion(howToUse_2, locale)
  const care1 = resolvePolishVersion(care_1, locale)
  const care2 = resolvePolishVersion(care_2, locale)
  const care3 = resolvePolishVersion(care_3, locale)
  const care4 = resolvePolishVersion(care_4, locale)
  const changeStraps1 = resolvePolishVersion(changeStraps_1, locale)
  const changeStraps2 = resolvePolishVersion(changeStraps_2, locale)
  const download1 = resolvePolishVersion(download_1, locale)

  // const listItems = [
  //   transformListObject(listOne, "#how-to-use"),
  //   transformListObject(listTwo, "#care-and-maintenance"),
  //   transformListObject(listThree, "#how-to-change-strap"),
  //   transformListObject(listFour, "#download-manual"),
  // ]

  // const [revealedSectionId, setRevealedSectionId] = useState<string | null>(
  //   null
  // )

  return (
    <>
      <QuickStartHeadingText headingText={headingText} />
      <QuickStartSectionWrapper id="how-to-use" revealedSectionId={""}>
        {listOne.text && (
          <StyledDesktopListItem>
            <RichText content={listOne.text} />
          </StyledDesktopListItem>
        )}
        <TextWithEmbedResolver {...howToUse1} />
        <TextWithEmbedResolver {...howToUse2} />
      </QuickStartSectionWrapper>
      <QuickStartSectionWrapper
        id="care-and-maintenance"
        revealedSectionId={""}
      >
        {listTwo.text && (
          <StyledDesktopListItem>
            <RichText content={listTwo.text} />
          </StyledDesktopListItem>
        )}
        <TextWithEmbedResolver {...care1} />
        <TextWithEmbedResolver {...care2} />
        <TextWithEmbedResolver {...care3} />
        <TextWithEmbedResolver {...care4} />
      </QuickStartSectionWrapper>
      <QuickStartSectionWrapper id="how-to-change-strap" revealedSectionId={""}>
        {listThree.text && (
          <StyledDesktopListItem>
            <RichText content={listThree.text} />
          </StyledDesktopListItem>
        )}
        {changeStraps1 && <TextWithEmbedResolver {...changeStraps1} />}
        <TextWithEmbedResolver {...changeStraps2} />
      </QuickStartSectionWrapper>
      <QuickStartSectionWrapper id="download-manual" revealedSectionId={""}>
        {listFour.text && (
          <StyledDesktopListItem>
            <RichText content={listFour.text} />
          </StyledDesktopListItem>
        )}
        <QuickStartHeadingText headingText={download1} />
        <QuickStartManualsTable manuals={manuals} />
      </QuickStartSectionWrapper>
    </>
  )
}

export default QuickStartElement

export const query = graphql`
  query QuickStartSliderElementQuery {
    contentfulText: allContentfulText(
      filter: { entryName: { eq: "Get started with how to guides element" } }
    ) {
      nodes {
        ...Text
        node_locale
      }
    }
    list_one: allContentfulListItem(
      filter: { entryName: { eq: "How to use your Element" } }
    ) {
      nodes {
        ...ListItem
        node_locale
      }
    }
    list_two: allContentfulListItem(
      filter: { entryName: { eq: "Care Maintenance" } }
    ) {
      nodes {
        ...ListItem
        node_locale
      }
    }
    list_three: allContentfulListItem(
      filter: { entryName: { eq: "How to change the strap element" } }
    ) {
      nodes {
        ...ListItem
        node_locale
      }
    }
    list_four: allContentfulListItem(
      filter: { entryName: { eq: "Download PDF manual element" } }
    ) {
      nodes {
        ...ListItem
        node_locale
      }
    }
    howToUse_1: allContentfulTextWithEmbed(
      filter: { entryName: { eq: "How to use 1" } }
    ) {
      nodes {
        ...TextWithEmbed
        node_locale
      }
    }
    howToUse_2: allContentfulTextWithEmbed(
      filter: { entryName: { eq: "How to use 2" } }
    ) {
      nodes {
        ...TextWithEmbed
        node_locale
      }
    }
    care_1: allContentfulTextWithEmbed(
      filter: { entryName: { eq: "Care 1" } }
    ) {
      nodes {
        ...TextWithEmbed
        node_locale
      }
    }
    care_2: allContentfulTextWithEmbed(
      filter: { entryName: { eq: "Care 2" } }
    ) {
      nodes {
        ...TextWithEmbed
        node_locale
      }
    }
    care_3: allContentfulTextWithEmbed(
      filter: { entryName: { eq: "Care 3" } }
    ) {
      nodes {
        ...TextWithEmbed
        node_locale
      }
    }
    care_4: allContentfulTextWithEmbed(
      filter: { entryName: { eq: "Care 4" } }
    ) {
      nodes {
        ...TextWithEmbed
        node_locale
      }
    }
    changeStraps_1: allContentfulTextWithEmbed(
      filter: { entryName: { eq: "Change strap 1" } }
    ) {
      nodes {
        ...TextWithEmbed
        node_locale
      }
    }
    changeStraps_2: allContentfulTextWithEmbed(
      filter: { entryName: { eq: "Change strap 2" } }
    ) {
      nodes {
        ...TextWithEmbed
        node_locale
      }
    }
    download_1: allContentfulText(
      filter: { entryName: { eq: "Download Your Ultimate Guide Element" } }
    ) {
      nodes {
        ...Text
        node_locale
      }
    }
  }
`
